var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardSurveys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.700195,
    width: 31,
    height: 31,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.700195,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "#E4E4E4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7381_152563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1056 7.42992C22.7002 7.02359 22.1609 6.7998 21.5872 6.7998H20.6182V6.60449C20.6182 6.06602 20.1801 5.62793 19.6416 5.62793H12.6104C12.0719 5.62793 11.6338 6.06602 11.6338 6.60449V6.7998H10.6613C9.47918 6.7998 8.51641 7.76254 8.51508 8.94586L8.49902 23.4771C8.4984 24.0514 8.72133 24.5915 9.12676 24.9978C9.53223 25.4041 10.0715 25.6279 10.6452 25.6279H21.5711C22.7532 25.6279 23.716 24.6652 23.7173 23.4819L23.7334 8.95062C23.7341 8.37629 23.5111 7.83621 23.1056 7.42992ZM12.8057 6.7998H19.4463V7.97168H12.8057V6.7998ZM22.5467 23.4805C22.5461 24.0185 22.1084 24.4561 21.5711 24.4561H10.6452C10.3844 24.4561 10.1393 24.3543 9.955 24.1696C9.7707 23.9849 9.66938 23.7395 9.66965 23.4784L9.6857 8.94719C9.68629 8.40926 10.1239 7.97168 10.6613 7.97168H11.6338V8.16699C11.6338 8.70547 12.0719 9.14355 12.6104 9.14355H19.6416C20.1801 9.14355 20.6182 8.70547 20.6182 8.16699V7.97168H21.5872C21.848 7.97168 22.0931 8.0734 22.2774 8.25809C22.4617 8.44277 22.5631 8.68828 22.5628 8.9493L22.5467 23.4805Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3154 13.4404H20.4784C20.802 13.4404 21.0643 13.1781 21.0643 12.8545C21.0643 12.5309 20.802 12.2686 20.4784 12.2686H16.3154C15.9918 12.2686 15.7295 12.5309 15.7295 12.8545C15.7295 13.1781 15.9918 13.4404 16.3154 13.4404Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3154 17.3467H20.4784C20.802 17.3467 21.0643 17.0843 21.0643 16.7607C21.0643 16.4371 20.802 16.1748 20.4784 16.1748H16.3154C15.9918 16.1748 15.7295 16.4371 15.7295 16.7607C15.7295 17.0843 15.9918 17.3467 16.3154 17.3467Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4951 20.0811H16.3154C15.9918 20.0811 15.7295 20.3434 15.7295 20.667C15.7295 20.9906 15.9918 21.2529 16.3154 21.2529H20.4951C20.8187 21.2529 21.0811 20.9906 21.0811 20.667C21.0811 20.3434 20.8187 20.0811 20.4951 20.0811Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8215 11.259L12.4702 12.6103L12.1516 12.2916C11.9228 12.0628 11.5518 12.0628 11.323 12.2916C11.0942 12.5204 11.0942 12.8914 11.323 13.1203L12.0559 13.8532C12.1658 13.9631 12.3148 14.0249 12.4703 14.0249C12.6256 14.0249 12.7747 13.9632 12.8846 13.8532L14.6501 12.0877C14.879 11.8589 14.879 11.4879 14.6501 11.2591C14.4213 11.0302 14.0503 11.0302 13.8215 11.259Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8215 15.4636L12.4702 16.8148L12.1516 16.4962C11.9228 16.2674 11.5518 16.2674 11.323 16.4962C11.0942 16.725 11.0942 17.096 11.323 17.3249L12.0559 18.0578C12.1658 18.1677 12.3148 18.2295 12.4703 18.2295C12.6256 18.2295 12.7747 18.1678 12.8846 18.0578L14.6501 16.2923C14.879 16.0635 14.879 15.6924 14.6501 15.4636C14.4213 15.2348 14.0503 15.2348 13.8215 15.4636Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8215 19.3698L12.4702 20.7211L12.1516 20.4025C11.9228 20.1737 11.5518 20.1737 11.323 20.4025C11.0942 20.6313 11.0942 21.0023 11.323 21.2311L12.0559 21.9641C12.1658 22.074 12.3148 22.1357 12.4703 22.1357C12.6256 22.1357 12.7747 22.074 12.8846 21.9641L14.6501 20.1985C14.879 19.9697 14.879 19.5987 14.6501 19.3699C14.4213 19.141 14.0503 19.141 13.8215 19.3698Z",
    fill: "#7F7F7F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7381_152563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6.11621 5.62793)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardSurveys);
export default __webpack_public_path__ + "static/media/dashboardSurveys.312d8c022e011e88a31fdcf4b6cb239a.svg";
export { ForwardRef as ReactComponent };